function formatCurrencyWithPrecision(value, currency, minimumFractionDigits, maximumFractionDigits) {
  if (value === null || value === undefined) return "—";
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "—";
  if (!currency) {
    return `${parsed.toLocaleString("de-DE", { minimumFractionDigits, maximumFractionDigits })} (Einheit unbestätigt)`;
  }
  try {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency,
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(parsed);
  } catch {
    return `${parsed.toLocaleString("de-DE", { minimumFractionDigits, maximumFractionDigits })} ${currency}`;
  }
}

export function formatCurrency(value, currency = "USD") {
  return formatCurrencyWithPrecision(value, currency, 2, 2);
}

export function money(value, currency = "USD") {
  return formatCurrencyWithPrecision(value, currency, 2, 2);
}

export function moneyPrecise(value, currency = "USD") {
  return formatCurrencyWithPrecision(value, currency, 2, 2);
}

export function stockPrice(value, currency = "USD") {
  if (value === null || value === undefined) return "—";
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "—";
  return Math.abs(parsed) >= 1
    ? formatCurrencyWithPrecision(parsed, currency, 2, 2)
    : formatCurrencyWithPrecision(parsed, currency, 2, 4);
}

export function formatQuantity(value) {
  if (value === null || value === undefined) return "—";
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "—";
  return parsed.toLocaleString("de-DE", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  });
}

export function formatPercent(value, digits = 2) {
  if (value === null || value === undefined) return "—";
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "—";
  const sign = parsed > 0 ? "+" : "";
  return `${sign}${parsed.toFixed(digits).replace(".", ",")} %`;
}

export function pct(value, digits = 2) {
  return formatPercent(value, digits);
}

export function toFiniteNumber(value, fallback = 0) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function downloadTextFile(filename, content, mimeType) {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
